<template>
    <span class="jumping-dots">
        <span class="dot-1">.</span>
        <span class="dot-2">.</span>
        <span class="dot-3">.</span>
    </span>
</template>

<script lang="ts">
export default {
  name: 'SeJumpingDots',
};
</script>
